

































































































































































































































































































































































































































































































































































// vue
import Vue from 'vue';
import {NOC, util, moment} from '@/class';
import * as NOCArray from '@/personal/array';
import utilComponents from '@/components/util';

// 部品
import WorkstyleEditer from '@/parts/setting/workstyle/WorkstyleEditer.vue';

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/setting/workstyle';

// parts
// import ModalMigrateConfirm from '@/components/util/ModalMigrateConfirm.vue';
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import SelectBox from '@/components/util/NewSelectBox.vue';

// validation
import * as validation from '@/personal/validation';
import {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';

// datepicker
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

interface IDispWorkstyle {
  name: '';
  workTime: '';
  restTime: '';
  holiday: string[];
  customHoliday: any[];
  cutoffDay: 0;
  weekFirst: '';
  yearFirst: '';
  legalHoliday: '';
  workstyleID: 0;
  workstyle: models.IWorkstyle;
}

export default Vue.extend({
  name: 'Workstyle',
  components: {
    ...utilComponents,
    WorkstyleEditer, ModalDeleteConfirm, /*ModalMigrateConfirm,*/ SelectBox, DatePicker,
  },
  props: {
    confirmDialog: Function,
  },
  data() {
    return {
      // get data
      workstyles: [] as models.IWorkstyle[],
      customHolidays: [] as models.ICustomHoliday[],
      customHolidayUseds: [] as models.ICustomHolidayUsed[],
      // select data
      selectDispWorkstyle: {} as IDispWorkstyle,
      delTargetCustomHoliday: {} as models.ICustomHoliday,
      // edit data
      editWorkstyle: {} as models.IWorkstyle,
      editCustomHolidayUseds: [] as models.ICustomHolidayUsed[],
      newCustomHoliday: null as models.ICustomHoliday | null,
      cutoffDayType: 0,
      cutoffDay: 1,
      cutoffDayError: '',
      // table data
      // items: [
      //   { key: 'workTime', label: '就業時間' },
      //   { key: 'restTime', label: '休憩時間' },
      //   { key: 'cutoffDay', label: '勤怠締め日' },
      //   { key: 'holiday', label: '休日の設定' },
      //   { key: 'customHoliday', label: 'カスタム休日' },
      // ],
      items: [
        {key: 'name', name: '就業形態名', type: INPUT_TYPE.TEXT, required: true, error: '', max: 20},
        {key: 'startTime', name: '始業時間', type: INPUT_TYPE.TIME, required: true, error: '', step: 900},
        {key: 'endTime', name: '終業時間', type: INPUT_TYPE.TIME, required: true, error: '', step: 900},
        {key: 'restTime', name: '休憩時間', type: INPUT_TYPE.TIME, required: true, error: '', step: 900},
        {key: 'cutoffDayType', name: '勤怠締め日', type: INPUT_TYPE.SELECT, required: true, error: '', options: NOCArray.CUTOFFDAY},
        {key: 'cutoffDay', name: '', type: INPUT_TYPE.NUMBER, required: false, error: '', min: 1, max: 28},
        {key: 'weekFirst', name: '週の起算日', type: INPUT_TYPE.RADIO, required: false, error: '', options: NOCArray.DAY_OF_WEEK},
        {key: 'legalHoliday', name: '', type: INPUT_TYPE.SELECT, required: false, error: '', options: NOCArray.LEGAL_HOLIDAY},
      ] as IVariableInput[],
      itemCustomHoliday: {
        key: 'name', name: '', type: INPUT_TYPE.TEXT, required: true, error: '', max: 15,
      } as IVariableInput,
      optionsWorkstyle: [NOC.SELECT.FIRST],
      mode: '',
      searchSideList: '',
      registCount: 0,
      migrateShowFlag: false,
      deleteCustomHolidayShowFlag: false,
      isDefault: true, // SP初期表示時はdefault:true
      DatePickerDateMD: 'M月d日',
      DatePickerDate: 'yyyy年M月d日',
      ja,
    };
  },
  directives: {
    DatePicker,
  },
  computed: {
    // MODE_NORMAL(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.NORMAL);
    // },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    // MODE_EDIT(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.EDIT);
    // },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
    // MODE_CHARGE(): boolean {
    //   return this.checkMode(NOC.SETTING.MODE.CHARGE);
    // },
    MODE_EDIT_BASE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_BASE);
    },
    // 画面表示用
    SIDE_LIST(): IDispWorkstyle[] {
      const dsipWorkstyles = this.workstyles
        .filter((v: models.IWorkstyle) => (v.name.indexOf(this.searchSideList) >= 0));

      // 増幅処理
      /*
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      dsipWorkstyles = dsipWorkstyles.concat(dsipWorkstyles);
      */

      // 表示する就業携帯を表示用に修正
      return dsipWorkstyles.map((val) => {
        // 週の起算日
        const weekFirst = NOCArray.DAY_OF_WEEK.find((v) => v.value === val.weekFirst);
        // 1年の起算日
        const yearFirstDate = new Date(val.yearFirst);
        const yearFirst = isNaN(yearFirstDate.getTime()) ? '未設定' : `${yearFirstDate.getMonth() + 1}月${yearFirstDate.getDate()}日`;
        // カスタム日付
        const holiday = val.holiday; // .join(', ');
        /*
        const count = this.customHolidayUseds
          .filter((useds: models.ICustomHolidayUsed) => (useds.workstyleID === val.workstyleID));
        if (count.length > 0) {
          holiday += holiday.length > 0 ? ', ' : '';
          holiday += 'カスタム休日';
        }
        */
        const useCustomHolidyID = this.customHolidayUseds
          .filter((useds: models.ICustomHolidayUsed) => (useds.workstyleID === val.workstyleID))
          .map((v) => (v.customHolidayID));
        const customHoliday = this.customHolidays.filter((v) => (useCustomHolidyID.includes(v.customHolidayID)))
          .map((v) => {
            const dateStr = moment.fncChangeStringToJPFormatNonZero(v.date);
            return {
              name: v.name,
              date: v.everyYear ? '毎年' + dateStr.substr(5, 6) : dateStr,
            };
          });
        // 法定休日
        const legalHoliday = NOCArray.LEGAL_HOLIDAY.find((v) => v.value === val.legalHoliday);
        return {
          name: val.name,
          workTime: val.startTime.slice(0, 5) + ' 〜 ' + val.endTime.slice(0, 5),
          restTime: val.restTime.slice(0, 5),
          holiday,
          cutoffDay: val.cutoffDay,
          weekFirst: weekFirst ? weekFirst.text + '曜日' : '未設定',
          yearFirst,
          legalHoliday: legalHoliday ? legalHoliday.text : NOC.SETTING.LEGALHOLIDAY.ONE,
          customHoliday,
          workstyleID: val.workstyleID,
          workstyle: val,
        } as IDispWorkstyle;
      });
    },
    CUTOFFDAY_LAST(): number {
      return NOC.SETTING.CUTOFFDAY.VALUE.LAST;
    },
    DAY_OF_WEEK() {
      return NOCArray.DAY_OF_WEEK;
    },
    DAY_OF_WEEK_HOLIDAY(): string[] {
      return [
        NOC.SETTING.HOLIDAY.MON,
        NOC.SETTING.HOLIDAY.TUE,
        NOC.SETTING.HOLIDAY.WED,
        NOC.SETTING.HOLIDAY.THU,
        NOC.SETTING.HOLIDAY.FRI,
        NOC.SETTING.HOLIDAY.SAT,
        NOC.SETTING.HOLIDAY.SUN,
        NOC.SETTING.HOLIDAY.JAPAN,
      ];
    },
    CUTOFFDAY_SELECT(): number {
      return NOC.SETTING.CUTOFFDAY.VALUE.SELECT;
    },
    CUTOFFDAY() {
      return NOCArray.CUTOFFDAY;
    },
    LEGAL_HOLIDAY() {
      return NOCArray.LEGAL_HOLIDAY;
    },
  },
  async mounted() {
    // データを取得
    this.mode = NOC.SETTING.MODE.CHARGE;
    this.$emit('pushPath', this.$route.path);
    const api = new API();
    const res = await api.get<models.VWorkstyle>('workstyle');
    // console.log(this.selectDispWorkstyle);
    // 成功時データ設定
    if (res.result) {
      this.workstyles = res.data.workstyles;
      this.customHolidays = res.data.customHolidays;
      this.customHolidayUseds = res.data.customHolidayUseds;
      this.mode = NOC.SETTING.MODE.NORMAL;
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }
    // this.$emit('pushPath', this.$route.path);
    // 初期表示のリストの先頭ユーザーを表示
    this.onSelectSideList(this.SIDE_LIST[0]);
  },
  methods: {
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    getItemID(v: models.IWorkstyle) {
      return v.workstyleID;
    },
    getItemText(v: models.IWorkstyle) {
      return v.name;
    },
    // サイドバー項目選択処理
    onSelectSideList(dispWorkstyle: IDispWorkstyle) {
      // if (this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)) {
      //   return;
      // }
      this.selectDispWorkstyle = dispWorkstyle;
      this.mode = NOC.SETTING.MODE.SELECT;
    },
    // サイドバークラス項目処理
    // classSideListActiveData(dispWorkstyle: IDispWorkstyle) {
    //   return {
    //     active : this.selectDispWorkstyle.workstyleID === dispWorkstyle.workstyleID,
    //   };
    // },
    onChange(value: any, item: validation.IPValidation) {
      validation.checkValue(value, item);
      this.customHolidays.splice(0, 0); // カスタム休日の変更検知用
    },
    // 新規ボタン押下時処理
    onClickNew() {
      window.scrollTo(0, 0);
      this.editWorkstyle = new models.CWorkstyle();
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // キャンセルボタン押下時処理
    onClickCancel() {
      window.scrollTo(0, 0);
      this.selectDispWorkstyle = {} as IDispWorkstyle;
      this.editWorkstyle = {} as models.IWorkstyle;
      this.mode = NOC.SETTING.MODE.NORMAL;
    },
    // 登録ボタン押下時処理
    async onClickRegist() {
      window.scrollTo(0, 0);
      // 値の設定
      let cd = this.cutoffDayType;
      this.cutoffDayError = '';
      let flag = false;

      // 日付選択の場合はその値を取得
      if ( cd === NOC.SETTING.CUTOFFDAY.VALUE.SELECT) {
        this.cutoffDay = Number(this.cutoffDay);
        if (1 > this.cutoffDay || this.cutoffDay >= 29) {
          // return;
          flag = true;
        }
        cd = this.cutoffDay;
      }
      this.editWorkstyle.cutoffDay = cd;
      // validation
      if (cd === NOC.SETTING.CUTOFFDAY.VALUE.LAST) {
        if (validation.checkValues(this.editWorkstyle, this.items.slice(0, 3)) > 0) {
          // return;
          flag = true;
        }
      } else {
        if (validation.checkValues(this.editWorkstyle, this.items) > 0) {
          // return;
          flag = true;
        }
      }

      const startTime = Number(this.editWorkstyle.startTime.split(':').slice(0, 2).join(''));
      const endTime = Number(this.editWorkstyle.endTime.split(':').slice(0, 2).join(''));
      const restTime = Number(this.editWorkstyle.restTime.split(':').slice(0, 2).join(''));

      // if (startTime < endTime) {
      //  this.items.filter((x: IVariableInput) => x.key === 'endTime')[0].error = '始業時間よりも早く設定されています。';
      //  return;
      // }
      if (startTime === endTime) {
        this.items.filter((x: IVariableInput) => x.key === 'startTime')[0].error = '始業時間が終業時間と同じです。';
        // return;
        flag = true;
      }

      if (startTime < endTime ) {
        if ((endTime - startTime -  restTime) <= 0) {
          this.items.filter((x: IVariableInput) => x.key === 'startTime')[0].error = '就業時間が0以下です。';
          // return;
          flag = true;
        }
      } else {
        if ((endTime + 2400 - (startTime + restTime)) <= 0) {
          this.items.filter((x: IVariableInput) => x.key === 'startTime')[0].error = '就業時間が0以下です。';
          // return;
          flag = true;
        }
      }
      if (flag) {
        return;
      }

      // 出力データ設定
      const emitData: models.VEditWorkStyle = {
        workstyle:  this.editWorkstyle,
        customHolidayUseds: this.editCustomHolidayUseds,
      };
      await this.registWorkstyle(emitData);
    },
    // 就業規約 登録処理
    async registWorkstyle(requestData: models.VEditWorkStyle) {
      // validationは別vueで行われる

      const api = new API();
      let res;

      if (this.checkMode(NOC.SETTING.MODE.NEW)) {
        // 新規登録
        res = await api.post<models.VEditWorkStyle, models.VWorkstyle>('workstyle/new', requestData);
      } else {
        // 更新
        res = await api.put<models.VEditWorkStyle, models.VWorkstyle>('workstyle/edit', requestData);
      }

      if (res.result) {
        this.workstyles = res.data.workstyles;
        this.customHolidayUseds = res.data.customHolidayUseds;
        this.selectBack();
        const selectData = this.SIDE_LIST.find((v) => v.workstyleID === requestData.workstyle.workstyleID);
        this.onSelectSideList(selectData || this.SIDE_LIST[0]);
      } else {
        // account参照
        this.$emit('info', '登録できませんでした。');
      }
    },
    // 就業形態削除処理
    async onClickDelete() {
      window.scrollTo(0, 0);
      // if (await this.confirmDialog('選択中の就業形態を削除します、よろしいでしょうか？')) {
      const workstyleID = this.selectDispWorkstyle.workstyleID;
      const api = new API();
      const res = await api.delete<models.VWorkstyle>('workstyle/delete', {deleteID: workstyleID});
      if (res.result) {
        this.workstyles = res.data.workstyles;
        this.customHolidayUseds = res.data.customHolidayUseds;
        this.onClickCancel();
        this.onSelectSideList(this.SIDE_LIST[0]);
      } else {
        this.$emit('info', '削除できませんでした。');
      }
    },
    // カスタム休日 新規作成処理
    onClickNewCustomHoliday() {
      this.newCustomHoliday = new models.CCustomHoliday();
      this.newCustomHoliday.validItem = JSON.parse(JSON.stringify(this.itemCustomHoliday));
    },
    onClickEditCustomHoliday(customHoliday: models.ICustomHoliday) {
      customHoliday.editData = JSON.parse(JSON.stringify(customHoliday));
      customHoliday.validItem = JSON.parse(JSON.stringify(this.itemCustomHoliday));
      customHoliday.editData!.editData = null;
      this.customHolidays.splice(0, 0); // 変更反映
    },
    onClickEditCancelCustomHoliday(customHoliday: models.ICustomHoliday) {
      customHoliday.editData = null;
      customHoliday.validItem = null;
      this.customHolidays.splice(0, 0); // 変更反映
    },
    // カスタム休日 登録処理
    async onClickRegistCustomHoliday(customHoliday: models.ICustomHoliday, validItem: validation.IPValidation) {
      // 入力チェック
      if (validation.checkValue(customHoliday.name, validItem)) {
        return;
      }
      customHoliday.date = moment.fncChangeStringToJPFormatNonZero(customHoliday.date);
      let result = false;
      // idの有無によって処理を変更
      if (customHoliday.customHolidayID === 0) {
        result = await this.registCustomHoliday(customHoliday);
      } else {
        result = await this.editCustomHoliday(customHoliday);
      }
      // 問題なく更新できた場合閉じる
      if (result) {
        this.newCustomHoliday = null;
      }
    },
    // カスタム休日 削除処理
    async onClickDeleteCustomHoliday(customHoliday: models.ICustomHoliday) {
      this.delTargetCustomHoliday = customHoliday;
      const customHolidayID = this.delTargetCustomHoliday.customHolidayID;
      const useCustomHoliday = this.customHolidayUseds.filter((v) => (v.customHolidayID === customHolidayID));
      if (useCustomHoliday.length > 0) {
        this.$emit('info', '使用中のカスタム日付のため削除できませんでした。');
        return false;
      }
      const api = new API();
      const res = await api.delete<models.VWorkstyle>('workstyle/customholiday/delete', {deleteID: customHolidayID});
      if (res.result) {
        this.customHolidays = res.data.customHolidays;
        // this.$emit('info', '削除しました。');
      } else {
        this.$emit('info', '削除できませんでした。');
        return false;
      }
      return true;
    },
    // カスタム休日 新規登録処理
    async registCustomHoliday(requestData: models.ICustomHoliday): Promise<boolean> {
      const api = new API();
      const res = await api.post<models.ICustomHoliday, models.VWorkstyle>(`workstyle/customholiday/new`, requestData);
      if (res.result) {
        this.customHolidays = res.data.customHolidays;
      } else {
        this.$emit('info', '登録できませんでした。');
        return false;
      }
      return true;
    },
    // カスタム休日 編集処理
    async editCustomHoliday(requestData: models.ICustomHoliday): Promise<boolean> {
      const api = new API();
      const res = await api.put<models.ICustomHoliday, models.VWorkstyle>(`workstyle/customholiday/edit`, requestData);
      if (res.result) {
        this.customHolidays = res.data.customHolidays;
      } else {
        this.$emit('info', '登録できませんでした。');
        return false;
      }
      return true;
    },
    // カスタム休日 削除処理
    // async deleteCustomHoliday(): Promise<boolean> {
    //   // if (await this.confirmDialog(name + ' を削除してよろしいですか？')) {
    //   const customHolidayID = this.delTargetCustomHoliday.customHolidayID;
    //   const useCustomHoliday = this.customHolidayUseds.filter((v) => (v.customHolidayID === customHolidayID));
    //   if (useCustomHoliday.length > 0) {
    //     this.$emit('info', '使用中のカスタム日付のため削除できませんでした。');
    //     return false;
    //   }
    //   const api = new API();
    //   const res = await api.delete<models.VWorkstyle>('workstyle/customholiday/delete', {deleteID: customHolidayID});
    //   if (res.result) {
    //     this.customHolidays = res.data.customHolidays;
    //     this.$emit('info', '削除しました。');
    //   } else {
    //     this.$emit('info', '削除できませんでした。');
    //     return false;
    //   }
    //   // }
    //   return true;
    // },
    fncChangeStringToJPFormatNonZero(date: string) {
      return moment.fncChangeStringToJPFormatNonZero(date);
    },
    // 削除
    migrateDelete() {
      this.migrateShowFlag = true;
    },
    closeModal() {
      this.migrateShowFlag = false;
    },
    // カスタム休日削除
    DeleteModalCustomHoliday(customHoliday: models.ICustomHoliday) {
      this.delTargetCustomHoliday = customHoliday;
      this.deleteCustomHolidayShowFlag = true;
    },
    closeModalCustomHoliday() {
      this.deleteCustomHolidayShowFlag = false;
    },
    // 編集データ作成
    setEditData() {
      // 締め日を設定
      const cd = this.editWorkstyle.cutoffDay;
      if (NOCArray.checkOptionsText(NOCArray.CUTOFFDAY, cd)) {
        this.cutoffDayType = cd;
      } else {
        this.cutoffDayType = NOC.SETTING.CUTOFFDAY.VALUE.SELECT;
        this.cutoffDay = cd;
      }
      // 入力エラーリセット
      for (const item of this.items) {
        item.error = '';
      }
      // カスタム休日編集データリセット
      for (const day of this.customHolidays) {
        day.editData = null;
        if (day.validItem) {
          day.validItem.error = '';
        }
      }
      this.newCustomHoliday = null;
    },
    // 基本情報の編集ボタン押下時処理
    onClickEditBase() {
      window.scrollTo(0, 0);
      this.editWorkstyle = JSON.parse(JSON.stringify(this.selectDispWorkstyle.workstyle));

      // カスタム休日設定
      this.editCustomHolidayUseds = JSON.parse(JSON.stringify(this.customHolidayUseds
        .filter((v: models.ICustomHolidayUsed) => (v.workstyleID === this.editWorkstyle.workstyleID))));
      this.mode = NOC.SETTING.MODE.EDIT_BASE;

      // 新規・編集共通の初期化処理
      this.setEditData();
    },
    // 戻る
    selectBack() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.SELECT;
      this.isDefault = true;
    },
    // 就業形態を追加
    addWorkstyle() {
      window.scrollTo(0, 0);
      this.editWorkstyle = new models.CWorkstyle();
      this.editCustomHolidayUseds = [];
      this.setEditData();
      this.mode = NOC.SETTING.MODE.NEW;
    },
  },
});
